/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Views_DeleteInputs */

const en_views_delete = /** @type {(inputs: Views_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete view`)
};

const de_views_delete = /** @type {(inputs: Views_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansicht löschen`)
};

/**
* | output |
* | --- |
* | "Delete view" |
*
* @param {Views_DeleteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_delete = /** @type {((inputs?: Views_DeleteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_DeleteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_delete(inputs)
	return en_views_delete(inputs)
});